import { Injectable, inject } from '@angular/core';
import { LocalStorageService } from 'ngx-localstorage';

@Injectable({ providedIn: 'root' })
export class SecureLocalStorageService {
    private readonly localStorage = inject(LocalStorageService);

    public getItem<TValue>(key: string): TValue | null {
        return this.localStorage.get<TValue>(key);
    }

    public removeItem(key: string): void {
        this.localStorage.remove(key);
    }

    public setItem<TValue>(key: string, data: TValue): void {
        this.localStorage.set<TValue>(key, data);
    }
}
